import { render } from "./Contract.vue?vue&type=template&id=44231ba4&scoped=true&lang=pug"
import script from "./Contract.vue?vue&type=script&setup=true&lang=js"
export * from "./Contract.vue?vue&type=script&setup=true&lang=js"

import "./Contract.vue?vue&type=style&index=0&id=44231ba4&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44231ba4"]])

export default __exports__